// Auto-generado por @xone-web/staticweb a partir de LoginColl.xne.
// NO EDITAR: se regenera en cada build.
// Eventos lifecycle + custom + sintéticos (onclick/onchange por prop).

import type { XoneAPI } from "../xone-api";
import type { LoginCollFields } from "./LoginColl.types";
export async function aceptarLogin(api: XoneAPI<LoginCollFields>): Promise<unknown> {
    const { self, This, ThisDataColl, ui, appData, $http, crypto, Bundle, console } = api;
    void self; void This; void ThisDataColl; void ui; void appData; void $http; void crypto; void Bundle; void console;
    
    var sUsuario = self.MAP_USUARIO;
                    var sPassword = self.MAP_PASSWORD;
                    var bUsuarioOK = (sUsuario && sUsuario !== "undefined" && sUsuario !== "null" && sUsuario.length > 0);
                    var bPasswordOK = (sPassword && sPassword !== "undefined" && sPassword !== "null" && sPassword.length > 0);

                    if (!bUsuarioOK) {
                        ui.showToast("Introduce tu usuario");
                    } else if (!bPasswordOK) {
                        ui.showToast("Introduce tu contrasena");
                    } else {
                        appData.login({
                            userName: sUsuario,
                            password: sPassword,
                            onLoginSuccessful: function() {
                                ui.showToast("Bienvenido!");
                            },
                            onLoginFailed: function() {
                                ui.showToast("Usuario o contrasena incorrectos");
                            }
                        });
                    }
}
export async function onback(api: XoneAPI<LoginCollFields>): Promise<unknown> {
    const { self, This, ThisDataColl, ui, appData, $http, crypto, Bundle, console } = api;
    void self; void This; void ThisDataColl; void ui; void appData; void $http; void crypto; void Bundle; void console;
    
    appData.failWithMessage(-11888, "##EXITAPP##");
}